export default "__VITE_ASSET__DofCe3MM__"